



























import BaseComponent from '@/components/base-component.vue';
import { listActiveClinicStates } from '@/services/clinic-states';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiRadioGroupsClinicStates extends BaseComponent {
  @Prop()
  public value: any;

  @Prop({ default: 'Estado Clínico' })
  public label?: string;

  @Prop({ default: false })
  public required?: boolean;

  @Prop({ default: false })
  public disabled?: boolean;

  @Prop({ default: true })
  public returnObject?: boolean;

  @Prop({ default: () => [] })
  private rules?: any[];

  loading = false;
  error = false;
  item = null;
  items = [];

  mounted() {
    this.load();
  }

  public onChange(val) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  private load(): void {
    this.item = null;
    this.loading = true;
    listActiveClinicStates().subscribe((res) => {
      this.items = res;
      this.loading = false;
      this.item = this.value;
    });
  }

  public onLinkClick(link) {
    window.open(link, 'doclink');
  }
}
